import { AppearanceTypes, useToasts } from 'react-toast-notifications';

export default function useCustomToast() {
	const { addToast } = useToasts();
	return (message: string, appearance: AppearanceTypes = 'success') => {
		addToast(message, { appearance });
	};
}
